<template>
  <div class="shops">
    <div class="topimg"><img src="@/assets/img/toppic2.png" alt="" /></div>
    <div class="contant" style="padding: 0 10px;">
      <!-- <div class="title" v-if="title" v-html="title"></div> -->
    <selectbox v-if="false" />
      <template v-for="(item,index) in fields" :key="index">
        <titletabs v-if= "item.type == 'title_tab'" :field="item"/>
    <!--   <div class="showdata">
        <datatabs :tabsData="tabslabel" :showsingle="true" :showmultiple="true" :textcolor="333" />
        <datacont />
      </div> -->
        <shoplist v-if= "item.type == 'table_tab'" :field="item" :title="item.text" titleColor="white" />
        <tableform v-if="item.type == 'table'" :field="item" />
        <echart v-if="item.type == 'map'" :field="item" :setId="index" />
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted,onUpdated } from "vue";
import mitts from "@/bus";
import { useRoute } from "vue-router";
// import datatabs from "@/components/datatabs";
// import datacont from "@/components/datacont";
import shoplist from "@/components/shoplist";
import titletabs from "@/components/titletabs";
import tableform from "@/components/table";
import echart from "@/components/echart";
import selectbox from "@/components/selectbox";
import API from "@/axios";

// const shoplistdata = ref(4);
// const tabslabel = ref(["今日", "昨日", "7日"]);
const route = useRoute();
const fields = ref([]);
const title = ref('');
let in_page = '';

function getData() {
  API({
    url: "/web/" + in_page,
    method: "get",
  }).then((res) => {
    fields.value=res.data.data.field;
    title.value = res.data.data.title;
    mitts.emit('navs', res.data.data.navs);
    setTimeout(() => {
      mitts.emit("closeLoading");
    }, 500);
  });
}

onMounted(() => {
  in_page = route.params.pt;
  getData();
  setTimeout(() => {
    mitts.emit("closeLoading");
  }, 500);
});
onUpdated(()=>{
  if(in_page && in_page != route.params.pt){
    in_page = route.params.pt;
    getData();
  }
});
</script>

<style lang="less" scoped>
.shops {
  position: relative;
  height: 100%;
  width: 100%;
  .topimg {
    width: 100%;
    img {
      width: 100%;
      display: block;
    }
  }
}
.contant {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-flow: column;
  box-sizing: border-box;
  .title {
    font-size: @title-size;
    font-weight: bolder;
    font-family: "Regular";
    color: @font-white-color;
    line-height: @title-size;
    padding: 60px 30px;
  }
  .showdata {
    padding: 0 30px;
    margin-bottom: 30px;
  }
}
</style>
